module.exports = __webpack_public_path__ + "static/media/ManageSub-BulkTemplate.9c2dd599.xlsx";